import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "catalog-search-input__suggestions"
};
const _hoisted_2 = { class: "catalog-search-input__suggestions-title" };
const _hoisted_3 = { class: "catalog-search-input__suggestions-values" };
import Icon from '@astina/paloma-common-ui/src/components/Icon.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CatalogSearchInputSuggestions',
    props: {
        suggestions: {},
        selected: {}
    },
    emits: ['close', 'select'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        return (_ctx, _cache) => {
            const _component_RouterLink = _resolveComponent("RouterLink");
            return (__props.suggestions.categories.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('search.suggested_categories')), 1),
                        _cache[1] || (_cache[1] = _createTextVNode()),
                        _createElementVNode("a", {
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (emit('close')), ["prevent"])),
                            href: ""
                        }, [
                            _createVNode(Icon, { name: "close" })
                        ])
                    ]),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.suggestions.categories, (cat) => {
                            return (_openBlock(), _createBlock(_component_RouterLink, {
                                to: { name: 'catalog_category', params: { category: cat.code } },
                                key: cat.code,
                                class: _normalizeClass(["catalog-search-input__suggestions-value", { 'catalog-search-input__suggestions-value--selected': cat.code === __props.selected?.code }]),
                                onClick: ($event) => (emit('select', cat))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(cat.name), 1)
                                ]),
                                _: 2
                            }, 1032, ["to", "class", "onClick"]));
                        }), 128))
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
